module.exports = require("iframe-resizer");